<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col sm="6">
          <base-material-card>
            <template v-slot:heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <va-field source="vat" ></va-field>
              <va-field source="county" ></va-field>
              <va-field source="reg_number" ></va-field>
              <va-field source="web" ></va-field>
              <va-field source="phone" ></va-field>
              <va-field source="address" ></va-field>
              <va-field source="zip" ></va-field>
              <va-field source="fax" ></va-field>
              <va-field source="name" ></va-field>
              <va-field source="city" ></va-field>
              <va-field source="email" ></va-field>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
